import request from '@/utils/request';

export function getUser(values) {
  return request('user', {
    method: 'GET',
    params: values,
  });
}

// 修改密码
export function changePassword(values, userId) {
  return request(`/users/${userId}/password`, {
    method: 'PUT',
    data: values,
  });
}
// 获取门店树形列表
export function getStoreTreeList() {
  return request('/store/queryTreeList', {
    method: 'GET',
  });
}
// 获取门店树形列表
export function getBookStoreTreeList() {
  return request('/activityBooking/queryConsumeStoreList', {
    method: 'GET',
  });
}
// 获取区域树形列表
export function getRegionList() {
  return request('/region/queryThreeList', {
    method: 'GET',
  });
}

// 所有字典
export function getDictAll() {
  return request('/config/queryDicts', {
    method: 'GET',
  });
}
// 查询自动回复规则
export function getQueryReplyRule(params) {
  return request('/wechat/reply/queryReplyRule', {
    method: 'POST',
    data: params,
  });
}
// 查询微信账号详情
export function getQueryAccountWeChat(params) {
  return request('/wechat/queryAccount', {
    method: 'POST',
    data: params,
  });
}

// 查询短信模板列表
export function getQuerySmsTemplateList(params) {
  return request('/sms/querySmsTemplateList', {
    method: 'POST',
    data: params,
  });
}
// 查询彩信模板列表
export function getQueryMmsTemplateList(params) {
  return request('/mms/querySmsTemplateList', {
    method: 'POST',
    data: params,
  });
}
// 查询公众号模板列表
export function getQueryWechatTemplatePage(params) {
  return request('/message/queryWechatTemplatePage', {
    method: 'POST',
    data: params,
  });
}
// 查询订阅消息
export function getQueryWmpTempMsgPage(params) {
  return request('/wechat/queryWmpTempMsgPage', {
    method: 'POST',
    data: params,
  });
}
